var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsNumber, IsUUID } from 'class-validator';
import { TrainingSessionItemLiteDto } from './training-session-item.lite.dto.js';
export class TrainingSessionProgressDto {
    totalCount;
    completedOrSkippedCount;
    percentageCompletedOrSkipped;
    nextTrainingSessionItem;
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], TrainingSessionProgressDto.prototype, "totalCount", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], TrainingSessionProgressDto.prototype, "completedOrSkippedCount", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], TrainingSessionProgressDto.prototype, "percentageCompletedOrSkipped", void 0);
__decorate([
    Expose(),
    IsUUID(),
    Type(() => TrainingSessionItemLiteDto),
    __metadata("design:type", Object)
], TrainingSessionProgressDto.prototype, "nextTrainingSessionItem", void 0);
//# sourceMappingURL=training-session-progress.dto.js.map